import * as React from 'react';
import { RegisterProspectUserDto } from '../../../../api/ProspectUser';
import { unformatPhoneNumber } from '../../../../utilities/Utils';
import FormPhoneInput from '../../../common/form/PhoneInput';
import ProfilePageInput from '../../../common/form/ProfilePageInput';
import ContactCheckbox from '../account/ContactCheckbox';

interface Props {
    userInfo: RegisterProspectUserDto;
    updateUserInfo: (field: string, value: string) => void;
    wasFormValidated: boolean;
    setValidData: any;
}

const ProspectSignupInputForm = (props: Props) => {
    const [emailChecked, setEmailChecked] = React.useState(false)
    const [phoneChecked, setPhoneChecked] = React.useState(false)
    const [contactError, setContactError] = React.useState('');
    const [emailError, setEmailError] = React.useState('');

    const updatePreferences = (emailEnabled: boolean, phoneEnabled: boolean) => {
        if (emailEnabled && phoneEnabled) {
            props.updateUserInfo("contactPreference", "3");
            setEmailChecked(true)
            setPhoneChecked(true)
        }

        if (!emailEnabled && phoneEnabled) {
            props.updateUserInfo("contactPreference", "1");
            setEmailChecked(false)
            setPhoneChecked(true)
        }

        if (emailEnabled && !phoneEnabled) {
            props.updateUserInfo("contactPreference", "2");
            setEmailChecked(true)
            setPhoneChecked(false)
        }
    };

    React.useEffect(() => {
        if (props.wasFormValidated && !emailChecked && !phoneChecked) {
            setContactError("Tour24 tours require either sms or email communications in order to function correctly, please choose at least one to continue sign up.");
        } else {
            setContactError('');
        }
    }, [props.wasFormValidated, emailChecked, phoneChecked]);

    const validateEmail = (email: string) => {
        props.updateUserInfo('email', email);

        if (!email.trim()) {
            setEmailError('');
            props.setValidData(false);
            return;
        }
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const consecutiveDotsPattern = /\.{2,}/;

        if (!emailPattern.test(email) || consecutiveDotsPattern.test(email)) {
            setEmailError('Please enter a valid email address.');
            props.setValidData(false);
        } else {
            setEmailError('');
            props.setValidData(true);
        }
    };

    React.useEffect(() => {
        if (props.wasFormValidated) {
            validateEmail(props.userInfo.email);
        }
    }, [props.wasFormValidated]);

    return (
        <div>
            <ProfilePageInput
                labelText="First Name"
                invalidText="Please enter your first name"
                id="first-name"
                name="firstName"
                value={props.userInfo.firstName}
                onChange={props.updateUserInfo}
                placeholder="EXACT ID First Name"
                boldTitle={true}
            />
            <ProfilePageInput
                labelText="Last Name"
                invalidText="Please enter your last name"
                id="last-name"
                name="lastName"
                value={props.userInfo.lastName}
                onChange={props.updateUserInfo}
                placeholder="EXACT ID Last Name"
                boldTitle={true}
            />
            <ProfilePageInput
                labelText="Email"
                invalidText={emailError || 'Please enter your email address'}
                validationMessage={emailError}
                type="email"
                id="email"
                name="email"
                value={props.userInfo.email}
                placeholder="Email to receive registration information"
                onChange={(_name, value) => validateEmail(value)}
                boldTitle={true}
            />
            <label htmlFor="phone-number" className="bold-profile-page-label">
                Cell
            </label>
            <FormPhoneInput
                labelProps={{}}
                inputProps={{
                    id: 'phone-number',
                    name: 'phoneNumber',
                    required: true,
                    value: props.userInfo.phoneNumber,
                    placeholder: "Number to receive registration code"
                }}
                helpTextProps={{
                    helpText: ''
                }}
                onChange={(inputName, newValue) =>
                    props.updateUserInfo(inputName, unformatPhoneNumber(newValue))
                }
            />
            <label className="bold-profile-page-label">
                How would you like to be contacted about tours?
            </label>
            <ContactCheckbox
                labelText="Email"
                checked={emailChecked}
                onClick={() => updatePreferences(!emailChecked, phoneChecked)}
                rowClassname="contact-check-top-margin"
                opacity={phoneChecked ? 1 : 0.65}
            />
            <ContactCheckbox
                labelText="Text"
                checked={phoneChecked}
                onClick={() => updatePreferences(emailChecked, !phoneChecked)}
                rowClassname="contact-check-between-margin contact-check-bottom-margin"
                opacity={emailChecked ? 1 : 0.65}
            />
            {contactError && (
                <p style={{ color: '#dc3545', fontSize: '12px' }}>{contactError}</p>
            )}
            <div style={{ display: "flex", flexDirection: "row", gap: '8px' }}>
                <p style={{ color: 'grey', fontSize: '12px', fontWeight: 'bold' }}>Note:</p>
                <p style={{ color: 'grey', fontSize: '12px' }}>By agreeing to SMS and email communications and scheduling a tour, you also allow the property and it's partners to contact you via both sms and email.</p>
            </div>
        </div>
    );
};

export default ProspectSignupInputForm;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/public/ProspectSignupInputForm.tsx